export default {
  campaigns: [],
  campaign: {},
  error: null,
  success: {},
};
